import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { DragScrollDirective } from '@df/ui/common/drag-scroll.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CMS_COMPONENT_CWV_CONFIG, ICmsComponentCwvConfig } from '../../../../config/component.config';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';

export interface IQuickLinksContent extends NICmsContentComponent.IData, ICmsComponentCwvConfig {
    quick_links_items: IQuickLinkItem[];
    quick_links_items_mobile?: IQuickLinkItemMobile[];
}

export interface IQuickLinkItem {
    image: string;
    text: string;
    link?: string;
    line_clamp?: boolean;
}

export interface IQuickLinkItemMobile {
    image: string;
    text: string;
    link?: string;
    line_clamp?: boolean;
}

@ICmsComponent<PageComponentQuickLinksComponent>({
    id: 'quick-links',
    name: 'Quick links',
    description: 'Quick links component',
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'quick_links_items',
            title: 'Quick Links',
            itemName: 'Item',
            itemNameField: 'text',
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image'
                },
                {
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Item text',
                    default: 'Some link',
                    required: true
                },
                {
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link'
                },
                <NICmsContentField.IField>{
                    key: 'line_clamp',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Enable line clamp',
                    default: false
                }
            ]
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'quick_links_items_mobile',
            title: 'Quick Links Mobile',
            itemName: 'Item',
            itemNameField: 'text',
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image'
                },
                {
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Item text',
                    default: 'Some link',
                    required: true
                },
                {
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link'
                },
                <NICmsContentField.IField>{
                    key: 'line_clamp',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Enable line clamp',
                    default: false
                }
            ]
        },
        ...CMS_COMPONENT_CWV_CONFIG
    ]
})
@Component({
    selector: 'page-component-quick-links',
    templateUrl: './quick-links.html',
    standalone: true,
    imports: [CommonModule, DfImageDirective, DragScrollDirective, HrefComponent, ICmsClientModule, SizeClassDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentQuickLinksComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IQuickLinksContent;

    get items() {
        if (this.client.isS && this.component.quick_links_items_mobile?.length) {
            return this.component.quick_links_items_mobile;
        }

        return this.component.quick_links_items;
    }
}
